/**
 * 三条创作线的独立页面(2026-08-07 IA 重构 I1)。
 *
 * ★一卡一页:片型不再是页面里的控件,而是**你点的是哪张卡**。
 *   三条线是三条真·不同的管线(引擎 / 参数集 / 产物 / 计费口径都不同),
 *   共用同一副骨架与同一套表单逻辑,由 `line` 分流。
 *
 * 页面壳故意做得很薄:所有逻辑在 `DigitalHumanCreatePage`(工作台本体)里,
 * 三条线只是把自己的身份告诉它 —— 将来某条线要长出专属块,也是往本体里按 line 加,
 * 而不是把整套表单复制三份。
 */
import DhWorkbench from "./DigitalHumanCreatePage";

export function DhTalkingPage() {
  return <DhWorkbench line="talking" />;
}

export function DhPhotoPage() {
  return <DhWorkbench line="photo" />;
}

export function DhTtsPage() {
  return <DhWorkbench line="tts" />;
}
